import { render, staticRenderFns } from "./CopyIndex.vue?vue&type=template&id=8d89520e&scoped=true"
import script from "./CopyIndex.vue?vue&type=script&lang=js"
export * from "./CopyIndex.vue?vue&type=script&lang=js"
import style0 from "./CopyIndex.vue?vue&type=style&index=0&id=8d89520e&prod&scoped=true&lang=css"
import style1 from "./CopyIndex.vue?vue&type=style&index=1&id=8d89520e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d89520e",
  null
  
)

export default component.exports